// Everything we fabricate — the public Inventory menu lists all of it, in stock or not.
export const MATERIALS = [
  {
    name: "Granite",
    tag: "Tough, heat-proof, one of a kind",
    blurb:
      "Quarried stone that shrugs off knives, hot pans and family life. No two slabs match, so you pick the piece you love and we cut your tops from that exact one.",
    seo: {
      title: "Granite Slabs & Countertops in Stock",
      description:
        "Browse granite slabs on the racks at Brioni Granite in St. Louis. See the exact piece photographed in our warehouse, then get a fabrication and installation quote.",
    },
  },
  {
    name: "Marble",
    tag: "Soft veining, timeless",
    blurb:
      "Cool to the touch with veining you will never see twice — the classic choice for a statement island or a vanity you look at every morning. Honed or polished, sealed before it leaves the shop.",
    seo: {
      title: "Marble Slabs & Countertops in Stock",
      description:
        "Marble slabs in stock now — Carrara, Calacatta and statement veining, photographed slab by slab. Visit the St. Louis warehouse or ask Brioni Granite for a quote.",
    },
  },
  {
    name: "Quartz",
    tag: "Consistent color, no sealing",
    blurb:
      "Engineered for a calm, repeatable look with nothing to reseal. Ideal for busy kitchens, laundries and anywhere the color has to match from one run to the next.",
    seo: {
      title: "Quartz Countertop Slabs in Stock",
      description:
        "Engineered quartz slabs in stock at Brioni Granite — consistent color, no sealing, ready to fabricate. Browse live stock and get a countertop quote in St. Louis.",
    },
  },
  {
    name: "Quartzite",
    tag: "Marble looks, granite strength",
    blurb:
      "The most asked-for stone on our floor: the drama of marble with the density of granite. Hard, unbothered by heat and happiest on a big island top.",
    seo: {
      title: "Quartzite Slabs & Countertops in Stock",
      description:
        "Quartzite slabs in stock — marble looks with granite toughness, ideal for island tops. See every piece on the rack at Brioni Granite, St. Louis, and request a quote.",
    },
  },
  {
    name: "Porcelain",
    tag: "Slim, UV-safe, outdoor-ready",
    blurb:
      "Large-format slabs that laugh at sun, stains and heat — the outdoor kitchen and full-height splashback favourite. Thin, light and very tough.",
    seo: {
      title: "Porcelain Slabs for Countertops & Outdoor Kitchens",
      description:
        "Large-format porcelain slabs in stock at Brioni Granite — UV-safe, heat-proof and perfect for outdoor kitchens and full-height splashbacks. Browse and get a quote.",
    },
  },
  {
    name: "Soapstone",
    tag: "Matte, warm, naturally sealed",
    blurb:
      "Naturally non-porous with a soft matte hand. It takes on a patina as you use it, so it suits a kitchen that is meant to look lived in.",
    seo: {
      title: "Soapstone Slabs & Countertops in Stock",
      description:
        "Soapstone slabs in stock — matte, naturally non-porous and full of character as it patinas. See the pieces at Brioni Granite in St. Louis and ask for a quote.",
    },
  },
  {
    name: "Onyx",
    tag: "Translucent and best backlit",
    blurb:
      "Dramatic, glassy and made for light behind it — a bar front or powder room nobody forgets. Fabricated with extra care and backing where it needs it.",
    seo: {
      title: "Onyx Slabs for Backlit Features & Bars",
      description:
        "Translucent onyx slabs in stock at Brioni Granite — made for backlit bar fronts and powder rooms. View the current pieces and talk to us about fabrication.",
    },
  },
];

export const VIEWS = {
  all: {
    label: "All inventory",
    micro: "Live stock",
    headline: "Inventory",
    blurb:
      "Every slab and remnant sitting on our racks right now, photographed as it landed. Filter it down, then come and see the piece in person.",
    seo: {
      title: "Slab Inventory — Granite, Marble, Quartz & Quartzite in Stock",
      description:
        "See every slab and remnant in stock at Brioni Granite in St. Louis, photographed piece by piece. Filter by material, color, finish and thickness, then book a viewing.",
    },
  },
  new: {
    label: "New arrivals",
    micro: "Just landed",
    headline: "New arrivals",
    blurb:
      "Straight off the latest container and onto the racks. Fresh colors move quickly, so it is worth booking a viewing before the weekend.",
    seo: {
      title: "New Slab Arrivals — Just Landed",
      description:
        "The newest slabs on our racks at Brioni Granite, straight off the latest container. Fresh colors move fast — see what has just landed and book a viewing.",
    },
  },
  sale: {
    label: "On sale",
    micro: "Sharper price",
    headline: "On sale",
    blurb:
      "End-of-lot slabs and one-off pieces at a keener price. What you see here is what is left — no reorders.",
    seo: {
      title: "Slabs On Sale — End of Lot Pieces",
      description:
        "Discounted slabs at Brioni Granite: end-of-lot and one-off pieces at a sharper price. What you see is what is left, so call the shop before it goes.",
    },
  },
  remnant: {
    label: "Remnants",
    micro: "Small pieces, big savings",
    headline: "Remnants",
    blurb:
      "Offcuts from finished jobs, priced to move. Perfect for vanities, hearths, tabletops and laundry tops at a fraction of a full slab — sizes are exactly as measured, first come first served.",
    seo: {
      title: "Stone Remnants for Vanities, Hearths & Tabletops",
      description:
        "Granite, marble and quartz remnants in stock at Brioni Granite, St. Louis. Ideal for vanities, hearths and tabletops at a fraction of a full slab — sizes as measured.",
    },
  },
};

export const MATERIAL_LINK = (name) =>
  `/inventory?material=${encodeURIComponent(name)}`;

export const QUICK_LINKS = [
  { slug: "all", to: "/inventory", label: VIEWS.all.label },
  { slug: "new", to: "/inventory?flag=new", label: VIEWS.new.label },
  { slug: "sale", to: "/inventory?flag=sale", label: VIEWS.sale.label },
];

export const REMNANT_LINK = { slug: "remnants", to: "/inventory?type=Remnant" };

// Collections menu: grouped catalogues (Material → Edges, Brands → Neolith …)
export const COLLECTIONS_MENU = [
  {
    group: "Material",
    slug: "material",
    items: [
      {
        slug: "edges",
        to: "/collections/material/edges",
        label: "Edges",
        tag: "Every profile we cut, single or laminated",
      },
    ],
  },
  {
    group: "Brands",
    slug: "brands",
    items: [
      {
        slug: "neolith",
        to: "/collections/brands/neolith",
        label: "Neolith",
        tag: "Sintered stone — the surface that does it all",
      },
      {
        slug: "silestone",
        to: "/collections/brands/silestone",
        label: "Silestone",
        tag: "Cosentino's HybriQ mineral-hybrid surfaces",
      },
      {
        slug: "viatera",
        to: "/collections/brands/viatera",
        label: "Viatera",
        tag: "LX Hausys quartz — made in the USA",
      },
      {
        slug: "msi",
        to: "/collections/brands/msi",
        label: "MSI",
        tag: "Q™ Premium quartz, granite, porcelain & more",
      },
      {
        slug: "stone-reserve",
        to: "/collections/brands/stone-reserve",
        label: "Stone Reserve",
        tag: "Rare & exotic natural stone — a curated reserve",
      },
      {
        slug: "two-rivers",
        to: "/collections/brands/two-rivers",
        label: "Two Rivers Stone Boutique",
        tag: "A boutique of natural stone from around the world",
      },
    ],
  },
];

// Trade menu: programs for builders, developers and designers.
export const TRADE_MENU = [
  {
    slug: "multi-family-commercial",
    to: "/trade/multi-family-commercial",
    label: "Multi-Family & Commercial Projects",
    tag: "Premium surfaces. Trusted timelines. Built for scale.",
  },
  {
    slug: "designers",
    to: "/trade/designers",
    label: "Designers",
    tag: "Design support without design limits.",
  },
  {
    slug: "contractors",
    to: "/trade/contractors",
    label: "Contractors",
    tag: "Fast quotes, full control, one project lead.",
  },
];

// Mobile drawer chips: materials, then the quick picks, then remnants last.
export const INVENTORY_MENU = [
  ...QUICK_LINKS.slice(0, 1),
  ...MATERIALS.map((m) => ({
    slug: m.name.toLowerCase(),
    to: MATERIAL_LINK(m.name),
    label: m.name,
  })),
  ...QUICK_LINKS.slice(1),
  { ...REMNANT_LINK, label: VIEWS.remnant.label },
];

// What the inventory page should say for the current filter.
export const pageCopy = ({ material, type, flag }) => {
  const stone = MATERIALS.find((m) => m.name === material);
  if (stone)
    return {
      micro: stone.tag,
      headline: stone.name,
      blurb: stone.blurb,
      seo: stone.seo,
    };
  if (flag === "new") return VIEWS.new;
  if (flag === "sale") return VIEWS.sale;
  if (type === "Remnant") return VIEWS.remnant;
  if (material)
    return {
      micro: "Live stock",
      headline: material,
      blurb: `Everything we have on the floor in ${material.toLowerCase()} right now. Nothing listed? Ask us — we source colors in every week.`,
      seo: {
        title: `${material} Slabs in Stock`,
        description: `Browse the ${material.toLowerCase()} slabs on our racks at Brioni Granite in St. Louis, photographed piece by piece, and ask us for a countertop quote.`,
      },
    };
  return VIEWS.all;
};

// "Company" dropdown — About us, Contact us and the Resources library
export const COMPANY_MENU = [
  {
    slug: "about",
    to: "/about",
    label: "About us",
    tag: "Our story, our shop and the people who cut your stone.",
  },
  {
    slug: "resources",
    to: "/resources",
    label: "Resources",
    tag: "Manufacturer warranties, care guides and technical documents.",
  },
  {
    slug: "contact",
    to: "/contact",
    label: "Contact us",
    tag: "Call, visit or send us your plans for a free quote.",
  },
];
